<template>
	<div class="couponList">
		<van-tabs v-model="active">
			<van-tab>
				<template #title>全部{{ couponNumber ?  '('+ couponNumber+')' : ''}}</template>
				<van-list
					v-model="loading"
					:finished="finished"
					:finished-text="finishedText"
					@load="onLoad"
				>
					<div v-if="allCouponList.length">
						<coupon-list-item v-for="(item,index) in allCouponList" :key="index" :info="item" :status="item.detailStatus" @refresh="refresh"></coupon-list-item>
					</div>
					<no-data v-if="!couponNumber" text="没有优惠券" :type="3"></no-data>
				</van-list>
			</van-tab>
			<van-tab>
				<template #title> 可用{{ canUseCouponNum ?  '('+ canUseCouponNum+')' : ''}}</template>
				<van-list
					v-model="loading"
					:finished="finished"
					:finished-text="finishedText"
					@load="onLoad"
				>
					<div v-if="canUseCouponList.length">
						<coupon-list-item v-for="(item,index) in canUseCouponList" :key="index" :info="item" :status="item.detailStatus"  @refresh="refresh"></coupon-list-item>
					</div>
					<no-data v-if="!canUseCouponNum" text="没有可用优惠券" :type="3"></no-data>
				</van-list>
			</van-tab>
			<van-tab>
				<template #title> 不可用{{ disUseCouponNum ?  '('+ disUseCouponNum +')' : ''}}</template>
				<van-list
					v-model="loading"
					:finished="finished"
					:finished-text="finishedText"
					@load="onLoad"
				>
					<div v-if="disUseCouponList.length">
						<coupon-list-item v-for="(item,index) in disUseCouponList" :key="index" :info="item" :status="item.detailStatus"  @refresh="refresh"></coupon-list-item>
					</div>
					<no-data v-if="!disUseCouponNum" text="没有不可用优惠券" :type="3"></no-data>
				</van-list>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import CouponListItem from './CouponListItem'
	import NoData from '../../../components/NoData'
	import { reqGetCouponList } from '../../../api';
	import { toNumber } from '../../../utils';
	import { mapGetters } from 'vuex';

	export default {
		name: 'couponList',
		components: {
			CouponListItem,
			NoData
		},
		data(){
			return {
				active: 0,  // 激活tab
				allCouponList:[], // 全部优惠券
				canUseCouponList: [], // 可用优惠券
				disUseCouponList: [], // 不可用优惠券
				page: 1,
				size: 10,
				couponObj: {
					0: 'allCouponList',
					1: 'canUseCouponList',
					2: 'disUseCouponList'
				},
				loading: false,
				finished: false
			}
		},
		watch: {
			// tab切换的时候
			active(value){
				this.active = value
				this.refresh()
			},
		},
		computed: {
			...mapGetters(['availableCouponNum','notAvailableCouponNum']),
			couponNumber: {
				get(){
					return toNumber(this.availableCouponNum)+ toNumber(this.disUseCouponNum) || 0
				},
				set(){
				}
			},
			canUseCouponNum: {
				get(){
					return toNumber(this.availableCouponNum) || 0
				},
				set(){
				}
			},
			disUseCouponNum: {
				get(){
					return toNumber(this.notAvailableCouponNum) || 0
				},
				set(){
				}
			},
			finishedText: {
				get(){
					return this.total>0 && this.finished === true ? '没有更多了' : ''
				},
				set(){
				}
			},
			total: {
				get(){
					return this[this.couponObj[this.active]].length || 0
				},
				set(){

				}
			},
		},
		mounted() {
			this.getCouponList()
			this.$nextTick(()=>{
				// eslint-disable-next-line
				sensors.track('tabCouponClick', {
					coupon_count: toNumber(this.availableCouponNum) || 0
				})
				})
		},
		methods: {
			// 列表加载
			onLoad() {
				this.page++
				this.getCouponList()
			},
			getCouponList() {
				let params = {
					page: this.page,
					size: this.size,
					type: this.active
				}
				this.loading = true
				reqGetCouponList(params).then((res)=>{
					let list = res.data
					this[this.couponObj[this.active]] = this[this.couponObj[this.active]].concat(list)
					this.loading = false
					if(res.data.length < this.size){
						this.finished = true
					}
				})
			},
			// 刷新数据
			refresh(){
				this[this.couponObj[this.active]] =  []
				this.loading= false
				this.finished = false
				this.page = 1
				this.getCouponList()
			}
		}
	};
</script>

